// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.32.1
// source: call-proto-generated.proto

/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";

export const protobufPackage = "";

export enum ByteFormat {
  PCM_8BIT = 0,
  PCM_16BIT = 1,
  PCM_24BIT = 2,
  PCM_32BIT = 3,
  FLOAT_32BIT = 4,
  UNRECOGNIZED = -1,
}

export function byteFormatFromJSON(object: any): ByteFormat {
  switch (object) {
    case 0:
    case "PCM_8BIT":
      return ByteFormat.PCM_8BIT;
    case 1:
    case "PCM_16BIT":
      return ByteFormat.PCM_16BIT;
    case 2:
    case "PCM_24BIT":
      return ByteFormat.PCM_24BIT;
    case 3:
    case "PCM_32BIT":
      return ByteFormat.PCM_32BIT;
    case 4:
    case "FLOAT_32BIT":
      return ByteFormat.FLOAT_32BIT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ByteFormat.UNRECOGNIZED;
  }
}

export function byteFormatToJSON(object: ByteFormat): string {
  switch (object) {
    case ByteFormat.PCM_8BIT:
      return "PCM_8BIT";
    case ByteFormat.PCM_16BIT:
      return "PCM_16BIT";
    case ByteFormat.PCM_24BIT:
      return "PCM_24BIT";
    case ByteFormat.PCM_32BIT:
      return "PCM_32BIT";
    case ByteFormat.FLOAT_32BIT:
      return "FLOAT_32BIT";
    case ByteFormat.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Encoding {
  LINEAR16 = 0,
  WEB_OPUS = 1,
  UNRECOGNIZED = -1,
}

export function encodingFromJSON(object: any): Encoding {
  switch (object) {
    case 0:
    case "LINEAR16":
      return Encoding.LINEAR16;
    case 1:
    case "WEB_OPUS":
      return Encoding.WEB_OPUS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Encoding.UNRECOGNIZED;
  }
}

export function encodingToJSON(object: Encoding): string {
  switch (object) {
    case Encoding.LINEAR16:
      return "LINEAR16";
    case Encoding.WEB_OPUS:
      return "WEB_OPUS";
    case Encoding.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum Status {
  STATUS_OK = 0,
  STATUS_ERROR = 1,
  UNRECOGNIZED = -1,
}

export function statusFromJSON(object: any): Status {
  switch (object) {
    case 0:
    case "STATUS_OK":
      return Status.STATUS_OK;
    case 1:
    case "STATUS_ERROR":
      return Status.STATUS_ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status.UNRECOGNIZED;
  }
}

export function statusToJSON(object: Status): string {
  switch (object) {
    case Status.STATUS_OK:
      return "STATUS_OK";
    case Status.STATUS_ERROR:
      return "STATUS_ERROR";
    case Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum AivyInterviewStatus {
  AIVY_INTERVIEW_STATUS_STARTED = 0,
  AIVY_INTERVIEW_STATUS_FINISHED = 1,
  UNRECOGNIZED = -1,
}

export function aivyInterviewStatusFromJSON(object: any): AivyInterviewStatus {
  switch (object) {
    case 0:
    case "AIVY_INTERVIEW_STATUS_STARTED":
      return AivyInterviewStatus.AIVY_INTERVIEW_STATUS_STARTED;
    case 1:
    case "AIVY_INTERVIEW_STATUS_FINISHED":
      return AivyInterviewStatus.AIVY_INTERVIEW_STATUS_FINISHED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AivyInterviewStatus.UNRECOGNIZED;
  }
}

export function aivyInterviewStatusToJSON(object: AivyInterviewStatus): string {
  switch (object) {
    case AivyInterviewStatus.AIVY_INTERVIEW_STATUS_STARTED:
      return "AIVY_INTERVIEW_STATUS_STARTED";
    case AivyInterviewStatus.AIVY_INTERVIEW_STATUS_FINISHED:
      return "AIVY_INTERVIEW_STATUS_FINISHED";
    case AivyInterviewStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MeetingMode {
  VIDEO = 0,
  AUDIO = 1,
  CHAT = 2,
  UNRECOGNIZED = -1,
}

export function meetingModeFromJSON(object: any): MeetingMode {
  switch (object) {
    case 0:
    case "VIDEO":
      return MeetingMode.VIDEO;
    case 1:
    case "AUDIO":
      return MeetingMode.AUDIO;
    case 2:
    case "CHAT":
      return MeetingMode.CHAT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MeetingMode.UNRECOGNIZED;
  }
}

export function meetingModeToJSON(object: MeetingMode): string {
  switch (object) {
    case MeetingMode.VIDEO:
      return "VIDEO";
    case MeetingMode.AUDIO:
      return "AUDIO";
    case MeetingMode.CHAT:
      return "CHAT";
    case MeetingMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AudioConfig {
  sampleRate: number;
  byteFormat: ByteFormat;
  encoding: Encoding;
}

export interface AudioChunkMessage {
  id: string;
  audioData: Uint8Array;
}

export interface PingMessage {
  callId?: string | undefined;
  text: string;
}

export interface PongMessage {
  callId: string;
  text: string;
}

export interface ClientToServerMessage {
  pingMessage?: PingMessage | undefined;
  audioChunkMessage?: AudioChunkMessage | undefined;
}

export interface PartialRecognitionMessage {
  text: string;
  isFinal: boolean;
  id: string;
}

export interface InterviewerPartialRecognitionMessage {
  text: string;
  isFinal: boolean;
  id: string;
}

export interface ImageVersion {
  url: string;
  fileSize: number;
  mimeType: string;
  width: number;
  height: number;
}

export interface ImageAttachment {
  fileName: string;
  versions: ImageVersion[];
  blurHash: string;
}

export interface GenerationIdAttachment {
  generationId: string;
}

export interface AivyInterviewStatusAttachment {
  interviewStatus: AivyInterviewStatus;
}

export interface AivyInterviewSwitchLanguageAttachment {
  languageCode: string;
}

export interface TextResponseMessage {
  text: string;
  id: string;
  userMessageId: string;
  answerMessageId: string;
  imageAttachments: ImageAttachment[];
  aivyInterviewStatusAttachments: AivyInterviewStatusAttachment[];
  aivyInterviewSwitchLanguageAttachment: AivyInterviewSwitchLanguageAttachment[];
  generationIdAttachment: GenerationIdAttachment[];
}

export interface VoiceResponseStart {
  config: AudioConfig | undefined;
  id: string;
  userMessageId: string;
  answerMessageId: string;
}

export interface VoiceResponseMessage {
  audioData: Uint8Array;
  id: string;
  userMessageId: string;
  answerMessageId: string;
}

export interface VoiceResponseEnd {
  id: string;
  userMessageId: string;
  answerMessageId: string;
}

export interface ServerToClientMessage {
  partialRecognitionMessage?: PartialRecognitionMessage | undefined;
  textResponseMessage?: TextResponseMessage | undefined;
  voiceResponseStart?: VoiceResponseStart | undefined;
  voiceResponseMessage?: VoiceResponseMessage | undefined;
  voiceResponseEnd?: VoiceResponseEnd | undefined;
}

export interface StartInterview {
  config: AudioConfig | undefined;
  userId: string;
  vacancyId: string;
  interruptionDisabled: boolean;
  isMobile: boolean;
  interviewId: string;
  isReconnect?: boolean | undefined;
}

/** Server sends to client */
export interface CallStarted {
  callId: string;
}

export interface EndOfUtterance {
  callId: string;
}

export interface VoiceActivityBegin {
  callId: string;
}

export interface StartListening {
  callId: string;
}

export interface SwitchLanguage {
  callId: string;
  languageCode: string;
}

export interface SwitchLanguageResponse {
  callId: string;
  languageCode: string;
}

export interface TextOutgoingMessage {
  callId: string;
  text: string;
}

export interface SwitchMeetingModeMessage {
  callId: string;
  meetingMode: MeetingMode;
}

export interface RequestSwitchMeetingMode {
  callId: string;
  meetingMode: MeetingMode;
  reason: string;
}

export interface ServiceErrorMessage {
  callId: string;
  reason: string;
}

export interface ClientToServerCallMessage {
  pingMessage?: PingMessage | undefined;
  audioChunkMessage?: AudioChunkMessage | undefined;
  startInterviewMessage?: StartInterview | undefined;
  switchLanguageMessage?: SwitchLanguage | undefined;
  textOutgoingMessage?: TextOutgoingMessage | undefined;
  requestSwitchingMode?: RequestSwitchMeetingMode | undefined;
}

export interface ServerToClientCallMessage {
  callStartedMessage?: CallStarted | undefined;
  partialRecognitionMessage?: PartialRecognitionMessage | undefined;
  textResponseMessage?: TextResponseMessage | undefined;
  voiceResponseStart?: VoiceResponseStart | undefined;
  voiceResponseMessage?: VoiceResponseMessage | undefined;
  voiceResponseEnd?: VoiceResponseEnd | undefined;
  endOfUtteranceMessage?: EndOfUtterance | undefined;
  voiceActivityBegin?: VoiceActivityBegin | undefined;
  interviewerPartialRecognitionMessage?: InterviewerPartialRecognitionMessage | undefined;
  switchLanguageResponseMessage?: SwitchLanguageResponse | undefined;
  pongMessage?: PongMessage | undefined;
  switchMeetingMode?: SwitchMeetingModeMessage | undefined;
  serviceErrorMessage?: ServiceErrorMessage | undefined;
}

function createBaseAudioConfig(): AudioConfig {
  return { sampleRate: 0, byteFormat: 0, encoding: 0 };
}

export const AudioConfig = {
  encode(message: AudioConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sampleRate !== 0) {
      writer.uint32(8).int32(message.sampleRate);
    }
    if (message.byteFormat !== 0) {
      writer.uint32(16).int32(message.byteFormat);
    }
    if (message.encoding !== 0) {
      writer.uint32(24).int32(message.encoding);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AudioConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.sampleRate = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.byteFormat = reader.int32() as any;
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.encoding = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AudioConfig {
    return {
      sampleRate: isSet(object.sampleRate) ? globalThis.Number(object.sampleRate) : 0,
      byteFormat: isSet(object.byteFormat) ? byteFormatFromJSON(object.byteFormat) : 0,
      encoding: isSet(object.encoding) ? encodingFromJSON(object.encoding) : 0,
    };
  },

  toJSON(message: AudioConfig): unknown {
    const obj: any = {};
    if (message.sampleRate !== 0) {
      obj.sampleRate = Math.round(message.sampleRate);
    }
    if (message.byteFormat !== 0) {
      obj.byteFormat = byteFormatToJSON(message.byteFormat);
    }
    if (message.encoding !== 0) {
      obj.encoding = encodingToJSON(message.encoding);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AudioConfig>, I>>(base?: I): AudioConfig {
    return AudioConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AudioConfig>, I>>(object: I): AudioConfig {
    const message = createBaseAudioConfig();
    message.sampleRate = object.sampleRate ?? 0;
    message.byteFormat = object.byteFormat ?? 0;
    message.encoding = object.encoding ?? 0;
    return message;
  },
};

function createBaseAudioChunkMessage(): AudioChunkMessage {
  return { id: "", audioData: new Uint8Array(0) };
}

export const AudioChunkMessage = {
  encode(message: AudioChunkMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.audioData.length !== 0) {
      writer.uint32(18).bytes(message.audioData);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AudioChunkMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAudioChunkMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.audioData = reader.bytes();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AudioChunkMessage {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      audioData: isSet(object.audioData) ? bytesFromBase64(object.audioData) : new Uint8Array(0),
    };
  },

  toJSON(message: AudioChunkMessage): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.audioData.length !== 0) {
      obj.audioData = base64FromBytes(message.audioData);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AudioChunkMessage>, I>>(base?: I): AudioChunkMessage {
    return AudioChunkMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AudioChunkMessage>, I>>(object: I): AudioChunkMessage {
    const message = createBaseAudioChunkMessage();
    message.id = object.id ?? "";
    message.audioData = object.audioData ?? new Uint8Array(0);
    return message;
  },
};

function createBasePingMessage(): PingMessage {
  return { callId: undefined, text: "" };
}

export const PingMessage = {
  encode(message: PingMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== undefined) {
      writer.uint32(10).string(message.callId);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PingMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PingMessage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : undefined,
      text: isSet(object.text) ? globalThis.String(object.text) : "",
    };
  },

  toJSON(message: PingMessage): unknown {
    const obj: any = {};
    if (message.callId !== undefined) {
      obj.callId = message.callId;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PingMessage>, I>>(base?: I): PingMessage {
    return PingMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PingMessage>, I>>(object: I): PingMessage {
    const message = createBasePingMessage();
    message.callId = object.callId ?? undefined;
    message.text = object.text ?? "";
    return message;
  },
};

function createBasePongMessage(): PongMessage {
  return { callId: "", text: "" };
}

export const PongMessage = {
  encode(message: PongMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PongMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePongMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PongMessage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
    };
  },

  toJSON(message: PongMessage): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PongMessage>, I>>(base?: I): PongMessage {
    return PongMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PongMessage>, I>>(object: I): PongMessage {
    const message = createBasePongMessage();
    message.callId = object.callId ?? "";
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseClientToServerMessage(): ClientToServerMessage {
  return { pingMessage: undefined, audioChunkMessage: undefined };
}

export const ClientToServerMessage = {
  encode(message: ClientToServerMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pingMessage !== undefined) {
      PingMessage.encode(message.pingMessage, writer.uint32(10).fork()).ldelim();
    }
    if (message.audioChunkMessage !== undefined) {
      AudioChunkMessage.encode(message.audioChunkMessage, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ClientToServerMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientToServerMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.pingMessage = PingMessage.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.audioChunkMessage = AudioChunkMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientToServerMessage {
    return {
      pingMessage: isSet(object.pingMessage) ? PingMessage.fromJSON(object.pingMessage) : undefined,
      audioChunkMessage: isSet(object.audioChunkMessage)
        ? AudioChunkMessage.fromJSON(object.audioChunkMessage)
        : undefined,
    };
  },

  toJSON(message: ClientToServerMessage): unknown {
    const obj: any = {};
    if (message.pingMessage !== undefined) {
      obj.pingMessage = PingMessage.toJSON(message.pingMessage);
    }
    if (message.audioChunkMessage !== undefined) {
      obj.audioChunkMessage = AudioChunkMessage.toJSON(message.audioChunkMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientToServerMessage>, I>>(base?: I): ClientToServerMessage {
    return ClientToServerMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientToServerMessage>, I>>(object: I): ClientToServerMessage {
    const message = createBaseClientToServerMessage();
    message.pingMessage = (object.pingMessage !== undefined && object.pingMessage !== null)
      ? PingMessage.fromPartial(object.pingMessage)
      : undefined;
    message.audioChunkMessage = (object.audioChunkMessage !== undefined && object.audioChunkMessage !== null)
      ? AudioChunkMessage.fromPartial(object.audioChunkMessage)
      : undefined;
    return message;
  },
};

function createBasePartialRecognitionMessage(): PartialRecognitionMessage {
  return { text: "", isFinal: false, id: "" };
}

export const PartialRecognitionMessage = {
  encode(message: PartialRecognitionMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.isFinal !== false) {
      writer.uint32(16).bool(message.isFinal);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PartialRecognitionMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePartialRecognitionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.isFinal = reader.bool();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PartialRecognitionMessage {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      isFinal: isSet(object.isFinal) ? globalThis.Boolean(object.isFinal) : false,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: PartialRecognitionMessage): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.isFinal !== false) {
      obj.isFinal = message.isFinal;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PartialRecognitionMessage>, I>>(base?: I): PartialRecognitionMessage {
    return PartialRecognitionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PartialRecognitionMessage>, I>>(object: I): PartialRecognitionMessage {
    const message = createBasePartialRecognitionMessage();
    message.text = object.text ?? "";
    message.isFinal = object.isFinal ?? false;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseInterviewerPartialRecognitionMessage(): InterviewerPartialRecognitionMessage {
  return { text: "", isFinal: false, id: "" };
}

export const InterviewerPartialRecognitionMessage = {
  encode(message: InterviewerPartialRecognitionMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.isFinal !== false) {
      writer.uint32(16).bool(message.isFinal);
    }
    if (message.id !== "") {
      writer.uint32(26).string(message.id);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InterviewerPartialRecognitionMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInterviewerPartialRecognitionMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.isFinal = reader.bool();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.id = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): InterviewerPartialRecognitionMessage {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      isFinal: isSet(object.isFinal) ? globalThis.Boolean(object.isFinal) : false,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: InterviewerPartialRecognitionMessage): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.isFinal !== false) {
      obj.isFinal = message.isFinal;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<InterviewerPartialRecognitionMessage>, I>>(
    base?: I,
  ): InterviewerPartialRecognitionMessage {
    return InterviewerPartialRecognitionMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InterviewerPartialRecognitionMessage>, I>>(
    object: I,
  ): InterviewerPartialRecognitionMessage {
    const message = createBaseInterviewerPartialRecognitionMessage();
    message.text = object.text ?? "";
    message.isFinal = object.isFinal ?? false;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseImageVersion(): ImageVersion {
  return { url: "", fileSize: 0, mimeType: "", width: 0, height: 0 };
}

export const ImageVersion = {
  encode(message: ImageVersion, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== "") {
      writer.uint32(10).string(message.url);
    }
    if (message.fileSize !== 0) {
      writer.uint32(24).int64(message.fileSize);
    }
    if (message.mimeType !== "") {
      writer.uint32(34).string(message.mimeType);
    }
    if (message.width !== 0) {
      writer.uint32(40).int32(message.width);
    }
    if (message.height !== 0) {
      writer.uint32(48).int32(message.height);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ImageVersion {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageVersion();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.url = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.fileSize = longToNumber(reader.int64() as Long);
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.mimeType = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.width = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.height = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageVersion {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : "",
      fileSize: isSet(object.fileSize) ? globalThis.Number(object.fileSize) : 0,
      mimeType: isSet(object.mimeType) ? globalThis.String(object.mimeType) : "",
      width: isSet(object.width) ? globalThis.Number(object.width) : 0,
      height: isSet(object.height) ? globalThis.Number(object.height) : 0,
    };
  },

  toJSON(message: ImageVersion): unknown {
    const obj: any = {};
    if (message.url !== "") {
      obj.url = message.url;
    }
    if (message.fileSize !== 0) {
      obj.fileSize = Math.round(message.fileSize);
    }
    if (message.mimeType !== "") {
      obj.mimeType = message.mimeType;
    }
    if (message.width !== 0) {
      obj.width = Math.round(message.width);
    }
    if (message.height !== 0) {
      obj.height = Math.round(message.height);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageVersion>, I>>(base?: I): ImageVersion {
    return ImageVersion.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageVersion>, I>>(object: I): ImageVersion {
    const message = createBaseImageVersion();
    message.url = object.url ?? "";
    message.fileSize = object.fileSize ?? 0;
    message.mimeType = object.mimeType ?? "";
    message.width = object.width ?? 0;
    message.height = object.height ?? 0;
    return message;
  },
};

function createBaseImageAttachment(): ImageAttachment {
  return { fileName: "", versions: [], blurHash: "" };
}

export const ImageAttachment = {
  encode(message: ImageAttachment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fileName !== "") {
      writer.uint32(10).string(message.fileName);
    }
    for (const v of message.versions) {
      ImageVersion.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    if (message.blurHash !== "") {
      writer.uint32(26).string(message.blurHash);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ImageAttachment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImageAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.fileName = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.versions.push(ImageVersion.decode(reader, reader.uint32()));
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.blurHash = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImageAttachment {
    return {
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : "",
      versions: globalThis.Array.isArray(object?.versions)
        ? object.versions.map((e: any) => ImageVersion.fromJSON(e))
        : [],
      blurHash: isSet(object.blurHash) ? globalThis.String(object.blurHash) : "",
    };
  },

  toJSON(message: ImageAttachment): unknown {
    const obj: any = {};
    if (message.fileName !== "") {
      obj.fileName = message.fileName;
    }
    if (message.versions?.length) {
      obj.versions = message.versions.map((e) => ImageVersion.toJSON(e));
    }
    if (message.blurHash !== "") {
      obj.blurHash = message.blurHash;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ImageAttachment>, I>>(base?: I): ImageAttachment {
    return ImageAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ImageAttachment>, I>>(object: I): ImageAttachment {
    const message = createBaseImageAttachment();
    message.fileName = object.fileName ?? "";
    message.versions = object.versions?.map((e) => ImageVersion.fromPartial(e)) || [];
    message.blurHash = object.blurHash ?? "";
    return message;
  },
};

function createBaseGenerationIdAttachment(): GenerationIdAttachment {
  return { generationId: "" };
}

export const GenerationIdAttachment = {
  encode(message: GenerationIdAttachment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.generationId !== "") {
      writer.uint32(10).string(message.generationId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GenerationIdAttachment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenerationIdAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.generationId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GenerationIdAttachment {
    return { generationId: isSet(object.generationId) ? globalThis.String(object.generationId) : "" };
  },

  toJSON(message: GenerationIdAttachment): unknown {
    const obj: any = {};
    if (message.generationId !== "") {
      obj.generationId = message.generationId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GenerationIdAttachment>, I>>(base?: I): GenerationIdAttachment {
    return GenerationIdAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GenerationIdAttachment>, I>>(object: I): GenerationIdAttachment {
    const message = createBaseGenerationIdAttachment();
    message.generationId = object.generationId ?? "";
    return message;
  },
};

function createBaseAivyInterviewStatusAttachment(): AivyInterviewStatusAttachment {
  return { interviewStatus: 0 };
}

export const AivyInterviewStatusAttachment = {
  encode(message: AivyInterviewStatusAttachment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.interviewStatus !== 0) {
      writer.uint32(8).int32(message.interviewStatus);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AivyInterviewStatusAttachment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAivyInterviewStatusAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.interviewStatus = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AivyInterviewStatusAttachment {
    return { interviewStatus: isSet(object.interviewStatus) ? aivyInterviewStatusFromJSON(object.interviewStatus) : 0 };
  },

  toJSON(message: AivyInterviewStatusAttachment): unknown {
    const obj: any = {};
    if (message.interviewStatus !== 0) {
      obj.interviewStatus = aivyInterviewStatusToJSON(message.interviewStatus);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AivyInterviewStatusAttachment>, I>>(base?: I): AivyInterviewStatusAttachment {
    return AivyInterviewStatusAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AivyInterviewStatusAttachment>, I>>(
    object: I,
  ): AivyInterviewStatusAttachment {
    const message = createBaseAivyInterviewStatusAttachment();
    message.interviewStatus = object.interviewStatus ?? 0;
    return message;
  },
};

function createBaseAivyInterviewSwitchLanguageAttachment(): AivyInterviewSwitchLanguageAttachment {
  return { languageCode: "" };
}

export const AivyInterviewSwitchLanguageAttachment = {
  encode(message: AivyInterviewSwitchLanguageAttachment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.languageCode !== "") {
      writer.uint32(10).string(message.languageCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AivyInterviewSwitchLanguageAttachment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAivyInterviewSwitchLanguageAttachment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.languageCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AivyInterviewSwitchLanguageAttachment {
    return { languageCode: isSet(object.languageCode) ? globalThis.String(object.languageCode) : "" };
  },

  toJSON(message: AivyInterviewSwitchLanguageAttachment): unknown {
    const obj: any = {};
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AivyInterviewSwitchLanguageAttachment>, I>>(
    base?: I,
  ): AivyInterviewSwitchLanguageAttachment {
    return AivyInterviewSwitchLanguageAttachment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AivyInterviewSwitchLanguageAttachment>, I>>(
    object: I,
  ): AivyInterviewSwitchLanguageAttachment {
    const message = createBaseAivyInterviewSwitchLanguageAttachment();
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseTextResponseMessage(): TextResponseMessage {
  return {
    text: "",
    id: "",
    userMessageId: "",
    answerMessageId: "",
    imageAttachments: [],
    aivyInterviewStatusAttachments: [],
    aivyInterviewSwitchLanguageAttachment: [],
    generationIdAttachment: [],
  };
}

export const TextResponseMessage = {
  encode(message: TextResponseMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.text !== "") {
      writer.uint32(10).string(message.text);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.userMessageId !== "") {
      writer.uint32(26).string(message.userMessageId);
    }
    if (message.answerMessageId !== "") {
      writer.uint32(34).string(message.answerMessageId);
    }
    for (const v of message.imageAttachments) {
      ImageAttachment.encode(v!, writer.uint32(42).fork()).ldelim();
    }
    for (const v of message.aivyInterviewStatusAttachments) {
      AivyInterviewStatusAttachment.encode(v!, writer.uint32(82).fork()).ldelim();
    }
    for (const v of message.aivyInterviewSwitchLanguageAttachment) {
      AivyInterviewSwitchLanguageAttachment.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    for (const v of message.generationIdAttachment) {
      GenerationIdAttachment.encode(v!, writer.uint32(106).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextResponseMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextResponseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.text = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userMessageId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.answerMessageId = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.imageAttachments.push(ImageAttachment.decode(reader, reader.uint32()));
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.aivyInterviewStatusAttachments.push(AivyInterviewStatusAttachment.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.aivyInterviewSwitchLanguageAttachment.push(
            AivyInterviewSwitchLanguageAttachment.decode(reader, reader.uint32()),
          );
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.generationIdAttachment.push(GenerationIdAttachment.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextResponseMessage {
    return {
      text: isSet(object.text) ? globalThis.String(object.text) : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userMessageId: isSet(object.userMessageId) ? globalThis.String(object.userMessageId) : "",
      answerMessageId: isSet(object.answerMessageId) ? globalThis.String(object.answerMessageId) : "",
      imageAttachments: globalThis.Array.isArray(object?.imageAttachments)
        ? object.imageAttachments.map((e: any) => ImageAttachment.fromJSON(e))
        : [],
      aivyInterviewStatusAttachments: globalThis.Array.isArray(object?.aivyInterviewStatusAttachments)
        ? object.aivyInterviewStatusAttachments.map((e: any) => AivyInterviewStatusAttachment.fromJSON(e))
        : [],
      aivyInterviewSwitchLanguageAttachment: globalThis.Array.isArray(object?.aivyInterviewSwitchLanguageAttachment)
        ? object.aivyInterviewSwitchLanguageAttachment.map((e: any) =>
          AivyInterviewSwitchLanguageAttachment.fromJSON(e)
        )
        : [],
      generationIdAttachment: globalThis.Array.isArray(object?.generationIdAttachment)
        ? object.generationIdAttachment.map((e: any) => GenerationIdAttachment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: TextResponseMessage): unknown {
    const obj: any = {};
    if (message.text !== "") {
      obj.text = message.text;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userMessageId !== "") {
      obj.userMessageId = message.userMessageId;
    }
    if (message.answerMessageId !== "") {
      obj.answerMessageId = message.answerMessageId;
    }
    if (message.imageAttachments?.length) {
      obj.imageAttachments = message.imageAttachments.map((e) => ImageAttachment.toJSON(e));
    }
    if (message.aivyInterviewStatusAttachments?.length) {
      obj.aivyInterviewStatusAttachments = message.aivyInterviewStatusAttachments.map((e) =>
        AivyInterviewStatusAttachment.toJSON(e)
      );
    }
    if (message.aivyInterviewSwitchLanguageAttachment?.length) {
      obj.aivyInterviewSwitchLanguageAttachment = message.aivyInterviewSwitchLanguageAttachment.map((e) =>
        AivyInterviewSwitchLanguageAttachment.toJSON(e)
      );
    }
    if (message.generationIdAttachment?.length) {
      obj.generationIdAttachment = message.generationIdAttachment.map((e) => GenerationIdAttachment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TextResponseMessage>, I>>(base?: I): TextResponseMessage {
    return TextResponseMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextResponseMessage>, I>>(object: I): TextResponseMessage {
    const message = createBaseTextResponseMessage();
    message.text = object.text ?? "";
    message.id = object.id ?? "";
    message.userMessageId = object.userMessageId ?? "";
    message.answerMessageId = object.answerMessageId ?? "";
    message.imageAttachments = object.imageAttachments?.map((e) => ImageAttachment.fromPartial(e)) || [];
    message.aivyInterviewStatusAttachments =
      object.aivyInterviewStatusAttachments?.map((e) => AivyInterviewStatusAttachment.fromPartial(e)) || [];
    message.aivyInterviewSwitchLanguageAttachment =
      object.aivyInterviewSwitchLanguageAttachment?.map((e) => AivyInterviewSwitchLanguageAttachment.fromPartial(e)) ||
      [];
    message.generationIdAttachment = object.generationIdAttachment?.map((e) => GenerationIdAttachment.fromPartial(e)) ||
      [];
    return message;
  },
};

function createBaseVoiceResponseStart(): VoiceResponseStart {
  return { config: undefined, id: "", userMessageId: "", answerMessageId: "" };
}

export const VoiceResponseStart = {
  encode(message: VoiceResponseStart, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.config !== undefined) {
      AudioConfig.encode(message.config, writer.uint32(10).fork()).ldelim();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.userMessageId !== "") {
      writer.uint32(26).string(message.userMessageId);
    }
    if (message.answerMessageId !== "") {
      writer.uint32(34).string(message.answerMessageId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceResponseStart {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceResponseStart();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.config = AudioConfig.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userMessageId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.answerMessageId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceResponseStart {
    return {
      config: isSet(object.config) ? AudioConfig.fromJSON(object.config) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userMessageId: isSet(object.userMessageId) ? globalThis.String(object.userMessageId) : "",
      answerMessageId: isSet(object.answerMessageId) ? globalThis.String(object.answerMessageId) : "",
    };
  },

  toJSON(message: VoiceResponseStart): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = AudioConfig.toJSON(message.config);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userMessageId !== "") {
      obj.userMessageId = message.userMessageId;
    }
    if (message.answerMessageId !== "") {
      obj.answerMessageId = message.answerMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceResponseStart>, I>>(base?: I): VoiceResponseStart {
    return VoiceResponseStart.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceResponseStart>, I>>(object: I): VoiceResponseStart {
    const message = createBaseVoiceResponseStart();
    message.config = (object.config !== undefined && object.config !== null)
      ? AudioConfig.fromPartial(object.config)
      : undefined;
    message.id = object.id ?? "";
    message.userMessageId = object.userMessageId ?? "";
    message.answerMessageId = object.answerMessageId ?? "";
    return message;
  },
};

function createBaseVoiceResponseMessage(): VoiceResponseMessage {
  return { audioData: new Uint8Array(0), id: "", userMessageId: "", answerMessageId: "" };
}

export const VoiceResponseMessage = {
  encode(message: VoiceResponseMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.audioData.length !== 0) {
      writer.uint32(10).bytes(message.audioData);
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    if (message.userMessageId !== "") {
      writer.uint32(26).string(message.userMessageId);
    }
    if (message.answerMessageId !== "") {
      writer.uint32(34).string(message.answerMessageId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceResponseMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceResponseMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.audioData = reader.bytes();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.userMessageId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.answerMessageId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceResponseMessage {
    return {
      audioData: isSet(object.audioData) ? bytesFromBase64(object.audioData) : new Uint8Array(0),
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userMessageId: isSet(object.userMessageId) ? globalThis.String(object.userMessageId) : "",
      answerMessageId: isSet(object.answerMessageId) ? globalThis.String(object.answerMessageId) : "",
    };
  },

  toJSON(message: VoiceResponseMessage): unknown {
    const obj: any = {};
    if (message.audioData.length !== 0) {
      obj.audioData = base64FromBytes(message.audioData);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userMessageId !== "") {
      obj.userMessageId = message.userMessageId;
    }
    if (message.answerMessageId !== "") {
      obj.answerMessageId = message.answerMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceResponseMessage>, I>>(base?: I): VoiceResponseMessage {
    return VoiceResponseMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceResponseMessage>, I>>(object: I): VoiceResponseMessage {
    const message = createBaseVoiceResponseMessage();
    message.audioData = object.audioData ?? new Uint8Array(0);
    message.id = object.id ?? "";
    message.userMessageId = object.userMessageId ?? "";
    message.answerMessageId = object.answerMessageId ?? "";
    return message;
  },
};

function createBaseVoiceResponseEnd(): VoiceResponseEnd {
  return { id: "", userMessageId: "", answerMessageId: "" };
}

export const VoiceResponseEnd = {
  encode(message: VoiceResponseEnd, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.userMessageId !== "") {
      writer.uint32(18).string(message.userMessageId);
    }
    if (message.answerMessageId !== "") {
      writer.uint32(26).string(message.answerMessageId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceResponseEnd {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceResponseEnd();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userMessageId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.answerMessageId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceResponseEnd {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      userMessageId: isSet(object.userMessageId) ? globalThis.String(object.userMessageId) : "",
      answerMessageId: isSet(object.answerMessageId) ? globalThis.String(object.answerMessageId) : "",
    };
  },

  toJSON(message: VoiceResponseEnd): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.userMessageId !== "") {
      obj.userMessageId = message.userMessageId;
    }
    if (message.answerMessageId !== "") {
      obj.answerMessageId = message.answerMessageId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceResponseEnd>, I>>(base?: I): VoiceResponseEnd {
    return VoiceResponseEnd.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceResponseEnd>, I>>(object: I): VoiceResponseEnd {
    const message = createBaseVoiceResponseEnd();
    message.id = object.id ?? "";
    message.userMessageId = object.userMessageId ?? "";
    message.answerMessageId = object.answerMessageId ?? "";
    return message;
  },
};

function createBaseServerToClientMessage(): ServerToClientMessage {
  return {
    partialRecognitionMessage: undefined,
    textResponseMessage: undefined,
    voiceResponseStart: undefined,
    voiceResponseMessage: undefined,
    voiceResponseEnd: undefined,
  };
}

export const ServerToClientMessage = {
  encode(message: ServerToClientMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.partialRecognitionMessage !== undefined) {
      PartialRecognitionMessage.encode(message.partialRecognitionMessage, writer.uint32(10).fork()).ldelim();
    }
    if (message.textResponseMessage !== undefined) {
      TextResponseMessage.encode(message.textResponseMessage, writer.uint32(18).fork()).ldelim();
    }
    if (message.voiceResponseStart !== undefined) {
      VoiceResponseStart.encode(message.voiceResponseStart, writer.uint32(26).fork()).ldelim();
    }
    if (message.voiceResponseMessage !== undefined) {
      VoiceResponseMessage.encode(message.voiceResponseMessage, writer.uint32(34).fork()).ldelim();
    }
    if (message.voiceResponseEnd !== undefined) {
      VoiceResponseEnd.encode(message.voiceResponseEnd, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ServerToClientMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerToClientMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.partialRecognitionMessage = PartialRecognitionMessage.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.textResponseMessage = TextResponseMessage.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.voiceResponseStart = VoiceResponseStart.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.voiceResponseMessage = VoiceResponseMessage.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.voiceResponseEnd = VoiceResponseEnd.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerToClientMessage {
    return {
      partialRecognitionMessage: isSet(object.partialRecognitionMessage)
        ? PartialRecognitionMessage.fromJSON(object.partialRecognitionMessage)
        : undefined,
      textResponseMessage: isSet(object.textResponseMessage)
        ? TextResponseMessage.fromJSON(object.textResponseMessage)
        : undefined,
      voiceResponseStart: isSet(object.voiceResponseStart)
        ? VoiceResponseStart.fromJSON(object.voiceResponseStart)
        : undefined,
      voiceResponseMessage: isSet(object.voiceResponseMessage)
        ? VoiceResponseMessage.fromJSON(object.voiceResponseMessage)
        : undefined,
      voiceResponseEnd: isSet(object.voiceResponseEnd) ? VoiceResponseEnd.fromJSON(object.voiceResponseEnd) : undefined,
    };
  },

  toJSON(message: ServerToClientMessage): unknown {
    const obj: any = {};
    if (message.partialRecognitionMessage !== undefined) {
      obj.partialRecognitionMessage = PartialRecognitionMessage.toJSON(message.partialRecognitionMessage);
    }
    if (message.textResponseMessage !== undefined) {
      obj.textResponseMessage = TextResponseMessage.toJSON(message.textResponseMessage);
    }
    if (message.voiceResponseStart !== undefined) {
      obj.voiceResponseStart = VoiceResponseStart.toJSON(message.voiceResponseStart);
    }
    if (message.voiceResponseMessage !== undefined) {
      obj.voiceResponseMessage = VoiceResponseMessage.toJSON(message.voiceResponseMessage);
    }
    if (message.voiceResponseEnd !== undefined) {
      obj.voiceResponseEnd = VoiceResponseEnd.toJSON(message.voiceResponseEnd);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerToClientMessage>, I>>(base?: I): ServerToClientMessage {
    return ServerToClientMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerToClientMessage>, I>>(object: I): ServerToClientMessage {
    const message = createBaseServerToClientMessage();
    message.partialRecognitionMessage =
      (object.partialRecognitionMessage !== undefined && object.partialRecognitionMessage !== null)
        ? PartialRecognitionMessage.fromPartial(object.partialRecognitionMessage)
        : undefined;
    message.textResponseMessage = (object.textResponseMessage !== undefined && object.textResponseMessage !== null)
      ? TextResponseMessage.fromPartial(object.textResponseMessage)
      : undefined;
    message.voiceResponseStart = (object.voiceResponseStart !== undefined && object.voiceResponseStart !== null)
      ? VoiceResponseStart.fromPartial(object.voiceResponseStart)
      : undefined;
    message.voiceResponseMessage = (object.voiceResponseMessage !== undefined && object.voiceResponseMessage !== null)
      ? VoiceResponseMessage.fromPartial(object.voiceResponseMessage)
      : undefined;
    message.voiceResponseEnd = (object.voiceResponseEnd !== undefined && object.voiceResponseEnd !== null)
      ? VoiceResponseEnd.fromPartial(object.voiceResponseEnd)
      : undefined;
    return message;
  },
};

function createBaseStartInterview(): StartInterview {
  return {
    config: undefined,
    userId: "",
    vacancyId: "",
    interruptionDisabled: false,
    isMobile: false,
    interviewId: "",
    isReconnect: undefined,
  };
}

export const StartInterview = {
  encode(message: StartInterview, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.config !== undefined) {
      AudioConfig.encode(message.config, writer.uint32(10).fork()).ldelim();
    }
    if (message.userId !== "") {
      writer.uint32(18).string(message.userId);
    }
    if (message.vacancyId !== "") {
      writer.uint32(26).string(message.vacancyId);
    }
    if (message.interruptionDisabled !== false) {
      writer.uint32(32).bool(message.interruptionDisabled);
    }
    if (message.isMobile !== false) {
      writer.uint32(40).bool(message.isMobile);
    }
    if (message.interviewId !== "") {
      writer.uint32(50).string(message.interviewId);
    }
    if (message.isReconnect !== undefined) {
      writer.uint32(72).bool(message.isReconnect);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartInterview {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartInterview();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.config = AudioConfig.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.vacancyId = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.interruptionDisabled = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.isMobile = reader.bool();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.interviewId = reader.string();
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.isReconnect = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartInterview {
    return {
      config: isSet(object.config) ? AudioConfig.fromJSON(object.config) : undefined,
      userId: isSet(object.userId) ? globalThis.String(object.userId) : "",
      vacancyId: isSet(object.vacancyId) ? globalThis.String(object.vacancyId) : "",
      interruptionDisabled: isSet(object.interruptionDisabled)
        ? globalThis.Boolean(object.interruptionDisabled)
        : false,
      isMobile: isSet(object.isMobile) ? globalThis.Boolean(object.isMobile) : false,
      interviewId: isSet(object.interviewId) ? globalThis.String(object.interviewId) : "",
      isReconnect: isSet(object.isReconnect) ? globalThis.Boolean(object.isReconnect) : undefined,
    };
  },

  toJSON(message: StartInterview): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = AudioConfig.toJSON(message.config);
    }
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    if (message.vacancyId !== "") {
      obj.vacancyId = message.vacancyId;
    }
    if (message.interruptionDisabled !== false) {
      obj.interruptionDisabled = message.interruptionDisabled;
    }
    if (message.isMobile !== false) {
      obj.isMobile = message.isMobile;
    }
    if (message.interviewId !== "") {
      obj.interviewId = message.interviewId;
    }
    if (message.isReconnect !== undefined) {
      obj.isReconnect = message.isReconnect;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartInterview>, I>>(base?: I): StartInterview {
    return StartInterview.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartInterview>, I>>(object: I): StartInterview {
    const message = createBaseStartInterview();
    message.config = (object.config !== undefined && object.config !== null)
      ? AudioConfig.fromPartial(object.config)
      : undefined;
    message.userId = object.userId ?? "";
    message.vacancyId = object.vacancyId ?? "";
    message.interruptionDisabled = object.interruptionDisabled ?? false;
    message.isMobile = object.isMobile ?? false;
    message.interviewId = object.interviewId ?? "";
    message.isReconnect = object.isReconnect ?? undefined;
    return message;
  },
};

function createBaseCallStarted(): CallStarted {
  return { callId: "" };
}

export const CallStarted = {
  encode(message: CallStarted, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CallStarted {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCallStarted();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CallStarted {
    return { callId: isSet(object.callId) ? globalThis.String(object.callId) : "" };
  },

  toJSON(message: CallStarted): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CallStarted>, I>>(base?: I): CallStarted {
    return CallStarted.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CallStarted>, I>>(object: I): CallStarted {
    const message = createBaseCallStarted();
    message.callId = object.callId ?? "";
    return message;
  },
};

function createBaseEndOfUtterance(): EndOfUtterance {
  return { callId: "" };
}

export const EndOfUtterance = {
  encode(message: EndOfUtterance, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EndOfUtterance {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEndOfUtterance();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EndOfUtterance {
    return { callId: isSet(object.callId) ? globalThis.String(object.callId) : "" };
  },

  toJSON(message: EndOfUtterance): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EndOfUtterance>, I>>(base?: I): EndOfUtterance {
    return EndOfUtterance.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EndOfUtterance>, I>>(object: I): EndOfUtterance {
    const message = createBaseEndOfUtterance();
    message.callId = object.callId ?? "";
    return message;
  },
};

function createBaseVoiceActivityBegin(): VoiceActivityBegin {
  return { callId: "" };
}

export const VoiceActivityBegin = {
  encode(message: VoiceActivityBegin, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VoiceActivityBegin {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVoiceActivityBegin();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): VoiceActivityBegin {
    return { callId: isSet(object.callId) ? globalThis.String(object.callId) : "" };
  },

  toJSON(message: VoiceActivityBegin): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VoiceActivityBegin>, I>>(base?: I): VoiceActivityBegin {
    return VoiceActivityBegin.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VoiceActivityBegin>, I>>(object: I): VoiceActivityBegin {
    const message = createBaseVoiceActivityBegin();
    message.callId = object.callId ?? "";
    return message;
  },
};

function createBaseStartListening(): StartListening {
  return { callId: "" };
}

export const StartListening = {
  encode(message: StartListening, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StartListening {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartListening();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartListening {
    return { callId: isSet(object.callId) ? globalThis.String(object.callId) : "" };
  },

  toJSON(message: StartListening): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartListening>, I>>(base?: I): StartListening {
    return StartListening.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartListening>, I>>(object: I): StartListening {
    const message = createBaseStartListening();
    message.callId = object.callId ?? "";
    return message;
  },
};

function createBaseSwitchLanguage(): SwitchLanguage {
  return { callId: "", languageCode: "" };
}

export const SwitchLanguage = {
  encode(message: SwitchLanguage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.languageCode !== "") {
      writer.uint32(18).string(message.languageCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchLanguage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchLanguage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.languageCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchLanguage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      languageCode: isSet(object.languageCode) ? globalThis.String(object.languageCode) : "",
    };
  },

  toJSON(message: SwitchLanguage): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchLanguage>, I>>(base?: I): SwitchLanguage {
    return SwitchLanguage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchLanguage>, I>>(object: I): SwitchLanguage {
    const message = createBaseSwitchLanguage();
    message.callId = object.callId ?? "";
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseSwitchLanguageResponse(): SwitchLanguageResponse {
  return { callId: "", languageCode: "" };
}

export const SwitchLanguageResponse = {
  encode(message: SwitchLanguageResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.languageCode !== "") {
      writer.uint32(18).string(message.languageCode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchLanguageResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchLanguageResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.languageCode = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchLanguageResponse {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      languageCode: isSet(object.languageCode) ? globalThis.String(object.languageCode) : "",
    };
  },

  toJSON(message: SwitchLanguageResponse): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.languageCode !== "") {
      obj.languageCode = message.languageCode;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchLanguageResponse>, I>>(base?: I): SwitchLanguageResponse {
    return SwitchLanguageResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchLanguageResponse>, I>>(object: I): SwitchLanguageResponse {
    const message = createBaseSwitchLanguageResponse();
    message.callId = object.callId ?? "";
    message.languageCode = object.languageCode ?? "";
    return message;
  },
};

function createBaseTextOutgoingMessage(): TextOutgoingMessage {
  return { callId: "", text: "" };
}

export const TextOutgoingMessage = {
  encode(message: TextOutgoingMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.text !== "") {
      writer.uint32(18).string(message.text);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextOutgoingMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTextOutgoingMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.text = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TextOutgoingMessage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      text: isSet(object.text) ? globalThis.String(object.text) : "",
    };
  },

  toJSON(message: TextOutgoingMessage): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.text !== "") {
      obj.text = message.text;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TextOutgoingMessage>, I>>(base?: I): TextOutgoingMessage {
    return TextOutgoingMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TextOutgoingMessage>, I>>(object: I): TextOutgoingMessage {
    const message = createBaseTextOutgoingMessage();
    message.callId = object.callId ?? "";
    message.text = object.text ?? "";
    return message;
  },
};

function createBaseSwitchMeetingModeMessage(): SwitchMeetingModeMessage {
  return { callId: "", meetingMode: 0 };
}

export const SwitchMeetingModeMessage = {
  encode(message: SwitchMeetingModeMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.meetingMode !== 0) {
      writer.uint32(16).int32(message.meetingMode);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SwitchMeetingModeMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSwitchMeetingModeMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.meetingMode = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SwitchMeetingModeMessage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      meetingMode: isSet(object.meetingMode) ? meetingModeFromJSON(object.meetingMode) : 0,
    };
  },

  toJSON(message: SwitchMeetingModeMessage): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.meetingMode !== 0) {
      obj.meetingMode = meetingModeToJSON(message.meetingMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SwitchMeetingModeMessage>, I>>(base?: I): SwitchMeetingModeMessage {
    return SwitchMeetingModeMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SwitchMeetingModeMessage>, I>>(object: I): SwitchMeetingModeMessage {
    const message = createBaseSwitchMeetingModeMessage();
    message.callId = object.callId ?? "";
    message.meetingMode = object.meetingMode ?? 0;
    return message;
  },
};

function createBaseRequestSwitchMeetingMode(): RequestSwitchMeetingMode {
  return { callId: "", meetingMode: 0, reason: "" };
}

export const RequestSwitchMeetingMode = {
  encode(message: RequestSwitchMeetingMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.meetingMode !== 0) {
      writer.uint32(24).int32(message.meetingMode);
    }
    if (message.reason !== "") {
      writer.uint32(34).string(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RequestSwitchMeetingMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRequestSwitchMeetingMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.meetingMode = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.reason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RequestSwitchMeetingMode {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      meetingMode: isSet(object.meetingMode) ? meetingModeFromJSON(object.meetingMode) : 0,
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: RequestSwitchMeetingMode): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.meetingMode !== 0) {
      obj.meetingMode = meetingModeToJSON(message.meetingMode);
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RequestSwitchMeetingMode>, I>>(base?: I): RequestSwitchMeetingMode {
    return RequestSwitchMeetingMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RequestSwitchMeetingMode>, I>>(object: I): RequestSwitchMeetingMode {
    const message = createBaseRequestSwitchMeetingMode();
    message.callId = object.callId ?? "";
    message.meetingMode = object.meetingMode ?? 0;
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseServiceErrorMessage(): ServiceErrorMessage {
  return { callId: "", reason: "" };
}

export const ServiceErrorMessage = {
  encode(message: ServiceErrorMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callId !== "") {
      writer.uint32(10).string(message.callId);
    }
    if (message.reason !== "") {
      writer.uint32(18).string(message.reason);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ServiceErrorMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServiceErrorMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.reason = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServiceErrorMessage {
    return {
      callId: isSet(object.callId) ? globalThis.String(object.callId) : "",
      reason: isSet(object.reason) ? globalThis.String(object.reason) : "",
    };
  },

  toJSON(message: ServiceErrorMessage): unknown {
    const obj: any = {};
    if (message.callId !== "") {
      obj.callId = message.callId;
    }
    if (message.reason !== "") {
      obj.reason = message.reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServiceErrorMessage>, I>>(base?: I): ServiceErrorMessage {
    return ServiceErrorMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServiceErrorMessage>, I>>(object: I): ServiceErrorMessage {
    const message = createBaseServiceErrorMessage();
    message.callId = object.callId ?? "";
    message.reason = object.reason ?? "";
    return message;
  },
};

function createBaseClientToServerCallMessage(): ClientToServerCallMessage {
  return {
    pingMessage: undefined,
    audioChunkMessage: undefined,
    startInterviewMessage: undefined,
    switchLanguageMessage: undefined,
    textOutgoingMessage: undefined,
    requestSwitchingMode: undefined,
  };
}

export const ClientToServerCallMessage = {
  encode(message: ClientToServerCallMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pingMessage !== undefined) {
      PingMessage.encode(message.pingMessage, writer.uint32(10).fork()).ldelim();
    }
    if (message.audioChunkMessage !== undefined) {
      AudioChunkMessage.encode(message.audioChunkMessage, writer.uint32(34).fork()).ldelim();
    }
    if (message.startInterviewMessage !== undefined) {
      StartInterview.encode(message.startInterviewMessage, writer.uint32(66).fork()).ldelim();
    }
    if (message.switchLanguageMessage !== undefined) {
      SwitchLanguage.encode(message.switchLanguageMessage, writer.uint32(90).fork()).ldelim();
    }
    if (message.textOutgoingMessage !== undefined) {
      TextOutgoingMessage.encode(message.textOutgoingMessage, writer.uint32(114).fork()).ldelim();
    }
    if (message.requestSwitchingMode !== undefined) {
      RequestSwitchMeetingMode.encode(message.requestSwitchingMode, writer.uint32(802).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ClientToServerCallMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClientToServerCallMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.pingMessage = PingMessage.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.audioChunkMessage = AudioChunkMessage.decode(reader, reader.uint32());
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.startInterviewMessage = StartInterview.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.switchLanguageMessage = SwitchLanguage.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.textOutgoingMessage = TextOutgoingMessage.decode(reader, reader.uint32());
          continue;
        case 100:
          if (tag !== 802) {
            break;
          }

          message.requestSwitchingMode = RequestSwitchMeetingMode.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClientToServerCallMessage {
    return {
      pingMessage: isSet(object.pingMessage) ? PingMessage.fromJSON(object.pingMessage) : undefined,
      audioChunkMessage: isSet(object.audioChunkMessage)
        ? AudioChunkMessage.fromJSON(object.audioChunkMessage)
        : undefined,
      startInterviewMessage: isSet(object.startInterviewMessage)
        ? StartInterview.fromJSON(object.startInterviewMessage)
        : undefined,
      switchLanguageMessage: isSet(object.switchLanguageMessage)
        ? SwitchLanguage.fromJSON(object.switchLanguageMessage)
        : undefined,
      textOutgoingMessage: isSet(object.textOutgoingMessage)
        ? TextOutgoingMessage.fromJSON(object.textOutgoingMessage)
        : undefined,
      requestSwitchingMode: isSet(object.requestSwitchingMode)
        ? RequestSwitchMeetingMode.fromJSON(object.requestSwitchingMode)
        : undefined,
    };
  },

  toJSON(message: ClientToServerCallMessage): unknown {
    const obj: any = {};
    if (message.pingMessage !== undefined) {
      obj.pingMessage = PingMessage.toJSON(message.pingMessage);
    }
    if (message.audioChunkMessage !== undefined) {
      obj.audioChunkMessage = AudioChunkMessage.toJSON(message.audioChunkMessage);
    }
    if (message.startInterviewMessage !== undefined) {
      obj.startInterviewMessage = StartInterview.toJSON(message.startInterviewMessage);
    }
    if (message.switchLanguageMessage !== undefined) {
      obj.switchLanguageMessage = SwitchLanguage.toJSON(message.switchLanguageMessage);
    }
    if (message.textOutgoingMessage !== undefined) {
      obj.textOutgoingMessage = TextOutgoingMessage.toJSON(message.textOutgoingMessage);
    }
    if (message.requestSwitchingMode !== undefined) {
      obj.requestSwitchingMode = RequestSwitchMeetingMode.toJSON(message.requestSwitchingMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClientToServerCallMessage>, I>>(base?: I): ClientToServerCallMessage {
    return ClientToServerCallMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClientToServerCallMessage>, I>>(object: I): ClientToServerCallMessage {
    const message = createBaseClientToServerCallMessage();
    message.pingMessage = (object.pingMessage !== undefined && object.pingMessage !== null)
      ? PingMessage.fromPartial(object.pingMessage)
      : undefined;
    message.audioChunkMessage = (object.audioChunkMessage !== undefined && object.audioChunkMessage !== null)
      ? AudioChunkMessage.fromPartial(object.audioChunkMessage)
      : undefined;
    message.startInterviewMessage =
      (object.startInterviewMessage !== undefined && object.startInterviewMessage !== null)
        ? StartInterview.fromPartial(object.startInterviewMessage)
        : undefined;
    message.switchLanguageMessage =
      (object.switchLanguageMessage !== undefined && object.switchLanguageMessage !== null)
        ? SwitchLanguage.fromPartial(object.switchLanguageMessage)
        : undefined;
    message.textOutgoingMessage = (object.textOutgoingMessage !== undefined && object.textOutgoingMessage !== null)
      ? TextOutgoingMessage.fromPartial(object.textOutgoingMessage)
      : undefined;
    message.requestSwitchingMode = (object.requestSwitchingMode !== undefined && object.requestSwitchingMode !== null)
      ? RequestSwitchMeetingMode.fromPartial(object.requestSwitchingMode)
      : undefined;
    return message;
  },
};

function createBaseServerToClientCallMessage(): ServerToClientCallMessage {
  return {
    callStartedMessage: undefined,
    partialRecognitionMessage: undefined,
    textResponseMessage: undefined,
    voiceResponseStart: undefined,
    voiceResponseMessage: undefined,
    voiceResponseEnd: undefined,
    endOfUtteranceMessage: undefined,
    voiceActivityBegin: undefined,
    interviewerPartialRecognitionMessage: undefined,
    switchLanguageResponseMessage: undefined,
    pongMessage: undefined,
    switchMeetingMode: undefined,
    serviceErrorMessage: undefined,
  };
}

export const ServerToClientCallMessage = {
  encode(message: ServerToClientCallMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.callStartedMessage !== undefined) {
      CallStarted.encode(message.callStartedMessage, writer.uint32(10).fork()).ldelim();
    }
    if (message.partialRecognitionMessage !== undefined) {
      PartialRecognitionMessage.encode(message.partialRecognitionMessage, writer.uint32(18).fork()).ldelim();
    }
    if (message.textResponseMessage !== undefined) {
      TextResponseMessage.encode(message.textResponseMessage, writer.uint32(26).fork()).ldelim();
    }
    if (message.voiceResponseStart !== undefined) {
      VoiceResponseStart.encode(message.voiceResponseStart, writer.uint32(34).fork()).ldelim();
    }
    if (message.voiceResponseMessage !== undefined) {
      VoiceResponseMessage.encode(message.voiceResponseMessage, writer.uint32(42).fork()).ldelim();
    }
    if (message.voiceResponseEnd !== undefined) {
      VoiceResponseEnd.encode(message.voiceResponseEnd, writer.uint32(50).fork()).ldelim();
    }
    if (message.endOfUtteranceMessage !== undefined) {
      EndOfUtterance.encode(message.endOfUtteranceMessage, writer.uint32(58).fork()).ldelim();
    }
    if (message.voiceActivityBegin !== undefined) {
      VoiceActivityBegin.encode(message.voiceActivityBegin, writer.uint32(74).fork()).ldelim();
    }
    if (message.interviewerPartialRecognitionMessage !== undefined) {
      InterviewerPartialRecognitionMessage.encode(
        message.interviewerPartialRecognitionMessage,
        writer.uint32(90).fork(),
      ).ldelim();
    }
    if (message.switchLanguageResponseMessage !== undefined) {
      SwitchLanguageResponse.encode(message.switchLanguageResponseMessage, writer.uint32(98).fork()).ldelim();
    }
    if (message.pongMessage !== undefined) {
      PongMessage.encode(message.pongMessage, writer.uint32(106).fork()).ldelim();
    }
    if (message.switchMeetingMode !== undefined) {
      SwitchMeetingModeMessage.encode(message.switchMeetingMode, writer.uint32(114).fork()).ldelim();
    }
    if (message.serviceErrorMessage !== undefined) {
      ServiceErrorMessage.encode(message.serviceErrorMessage, writer.uint32(122).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ServerToClientCallMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseServerToClientCallMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.callStartedMessage = CallStarted.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.partialRecognitionMessage = PartialRecognitionMessage.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.textResponseMessage = TextResponseMessage.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.voiceResponseStart = VoiceResponseStart.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.voiceResponseMessage = VoiceResponseMessage.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.voiceResponseEnd = VoiceResponseEnd.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.endOfUtteranceMessage = EndOfUtterance.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.voiceActivityBegin = VoiceActivityBegin.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.interviewerPartialRecognitionMessage = InterviewerPartialRecognitionMessage.decode(
            reader,
            reader.uint32(),
          );
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.switchLanguageResponseMessage = SwitchLanguageResponse.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.pongMessage = PongMessage.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.switchMeetingMode = SwitchMeetingModeMessage.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.serviceErrorMessage = ServiceErrorMessage.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ServerToClientCallMessage {
    return {
      callStartedMessage: isSet(object.callStartedMessage)
        ? CallStarted.fromJSON(object.callStartedMessage)
        : undefined,
      partialRecognitionMessage: isSet(object.partialRecognitionMessage)
        ? PartialRecognitionMessage.fromJSON(object.partialRecognitionMessage)
        : undefined,
      textResponseMessage: isSet(object.textResponseMessage)
        ? TextResponseMessage.fromJSON(object.textResponseMessage)
        : undefined,
      voiceResponseStart: isSet(object.voiceResponseStart)
        ? VoiceResponseStart.fromJSON(object.voiceResponseStart)
        : undefined,
      voiceResponseMessage: isSet(object.voiceResponseMessage)
        ? VoiceResponseMessage.fromJSON(object.voiceResponseMessage)
        : undefined,
      voiceResponseEnd: isSet(object.voiceResponseEnd) ? VoiceResponseEnd.fromJSON(object.voiceResponseEnd) : undefined,
      endOfUtteranceMessage: isSet(object.endOfUtteranceMessage)
        ? EndOfUtterance.fromJSON(object.endOfUtteranceMessage)
        : undefined,
      voiceActivityBegin: isSet(object.voiceActivityBegin)
        ? VoiceActivityBegin.fromJSON(object.voiceActivityBegin)
        : undefined,
      interviewerPartialRecognitionMessage: isSet(object.interviewerPartialRecognitionMessage)
        ? InterviewerPartialRecognitionMessage.fromJSON(object.interviewerPartialRecognitionMessage)
        : undefined,
      switchLanguageResponseMessage: isSet(object.switchLanguageResponseMessage)
        ? SwitchLanguageResponse.fromJSON(object.switchLanguageResponseMessage)
        : undefined,
      pongMessage: isSet(object.pongMessage) ? PongMessage.fromJSON(object.pongMessage) : undefined,
      switchMeetingMode: isSet(object.switchMeetingMode)
        ? SwitchMeetingModeMessage.fromJSON(object.switchMeetingMode)
        : undefined,
      serviceErrorMessage: isSet(object.serviceErrorMessage)
        ? ServiceErrorMessage.fromJSON(object.serviceErrorMessage)
        : undefined,
    };
  },

  toJSON(message: ServerToClientCallMessage): unknown {
    const obj: any = {};
    if (message.callStartedMessage !== undefined) {
      obj.callStartedMessage = CallStarted.toJSON(message.callStartedMessage);
    }
    if (message.partialRecognitionMessage !== undefined) {
      obj.partialRecognitionMessage = PartialRecognitionMessage.toJSON(message.partialRecognitionMessage);
    }
    if (message.textResponseMessage !== undefined) {
      obj.textResponseMessage = TextResponseMessage.toJSON(message.textResponseMessage);
    }
    if (message.voiceResponseStart !== undefined) {
      obj.voiceResponseStart = VoiceResponseStart.toJSON(message.voiceResponseStart);
    }
    if (message.voiceResponseMessage !== undefined) {
      obj.voiceResponseMessage = VoiceResponseMessage.toJSON(message.voiceResponseMessage);
    }
    if (message.voiceResponseEnd !== undefined) {
      obj.voiceResponseEnd = VoiceResponseEnd.toJSON(message.voiceResponseEnd);
    }
    if (message.endOfUtteranceMessage !== undefined) {
      obj.endOfUtteranceMessage = EndOfUtterance.toJSON(message.endOfUtteranceMessage);
    }
    if (message.voiceActivityBegin !== undefined) {
      obj.voiceActivityBegin = VoiceActivityBegin.toJSON(message.voiceActivityBegin);
    }
    if (message.interviewerPartialRecognitionMessage !== undefined) {
      obj.interviewerPartialRecognitionMessage = InterviewerPartialRecognitionMessage.toJSON(
        message.interviewerPartialRecognitionMessage,
      );
    }
    if (message.switchLanguageResponseMessage !== undefined) {
      obj.switchLanguageResponseMessage = SwitchLanguageResponse.toJSON(message.switchLanguageResponseMessage);
    }
    if (message.pongMessage !== undefined) {
      obj.pongMessage = PongMessage.toJSON(message.pongMessage);
    }
    if (message.switchMeetingMode !== undefined) {
      obj.switchMeetingMode = SwitchMeetingModeMessage.toJSON(message.switchMeetingMode);
    }
    if (message.serviceErrorMessage !== undefined) {
      obj.serviceErrorMessage = ServiceErrorMessage.toJSON(message.serviceErrorMessage);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ServerToClientCallMessage>, I>>(base?: I): ServerToClientCallMessage {
    return ServerToClientCallMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ServerToClientCallMessage>, I>>(object: I): ServerToClientCallMessage {
    const message = createBaseServerToClientCallMessage();
    message.callStartedMessage = (object.callStartedMessage !== undefined && object.callStartedMessage !== null)
      ? CallStarted.fromPartial(object.callStartedMessage)
      : undefined;
    message.partialRecognitionMessage =
      (object.partialRecognitionMessage !== undefined && object.partialRecognitionMessage !== null)
        ? PartialRecognitionMessage.fromPartial(object.partialRecognitionMessage)
        : undefined;
    message.textResponseMessage = (object.textResponseMessage !== undefined && object.textResponseMessage !== null)
      ? TextResponseMessage.fromPartial(object.textResponseMessage)
      : undefined;
    message.voiceResponseStart = (object.voiceResponseStart !== undefined && object.voiceResponseStart !== null)
      ? VoiceResponseStart.fromPartial(object.voiceResponseStart)
      : undefined;
    message.voiceResponseMessage = (object.voiceResponseMessage !== undefined && object.voiceResponseMessage !== null)
      ? VoiceResponseMessage.fromPartial(object.voiceResponseMessage)
      : undefined;
    message.voiceResponseEnd = (object.voiceResponseEnd !== undefined && object.voiceResponseEnd !== null)
      ? VoiceResponseEnd.fromPartial(object.voiceResponseEnd)
      : undefined;
    message.endOfUtteranceMessage =
      (object.endOfUtteranceMessage !== undefined && object.endOfUtteranceMessage !== null)
        ? EndOfUtterance.fromPartial(object.endOfUtteranceMessage)
        : undefined;
    message.voiceActivityBegin = (object.voiceActivityBegin !== undefined && object.voiceActivityBegin !== null)
      ? VoiceActivityBegin.fromPartial(object.voiceActivityBegin)
      : undefined;
    message.interviewerPartialRecognitionMessage =
      (object.interviewerPartialRecognitionMessage !== undefined &&
          object.interviewerPartialRecognitionMessage !== null)
        ? InterviewerPartialRecognitionMessage.fromPartial(object.interviewerPartialRecognitionMessage)
        : undefined;
    message.switchLanguageResponseMessage =
      (object.switchLanguageResponseMessage !== undefined && object.switchLanguageResponseMessage !== null)
        ? SwitchLanguageResponse.fromPartial(object.switchLanguageResponseMessage)
        : undefined;
    message.pongMessage = (object.pongMessage !== undefined && object.pongMessage !== null)
      ? PongMessage.fromPartial(object.pongMessage)
      : undefined;
    message.switchMeetingMode = (object.switchMeetingMode !== undefined && object.switchMeetingMode !== null)
      ? SwitchMeetingModeMessage.fromPartial(object.switchMeetingMode)
      : undefined;
    message.serviceErrorMessage = (object.serviceErrorMessage !== undefined && object.serviceErrorMessage !== null)
      ? ServiceErrorMessage.fromPartial(object.serviceErrorMessage)
      : undefined;
    return message;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  const bin = globalThis.atob(b64);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; ++i) {
    arr[i] = bin.charCodeAt(i);
  }
  return arr;
}

function base64FromBytes(arr: Uint8Array): string {
  const bin: string[] = [];
  arr.forEach((byte) => {
    bin.push(globalThis.String.fromCharCode(byte));
  });
  return globalThis.btoa(bin.join(""));
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
